<template>
  <div>
    <b-row class="mb-2">
      <b-col
        cols="12"
        md="6"
        lg="4"
      >
        <b-form-group :label="$t('project')">
          <b-form-select
            v-model="selectedProjectId"
            :options="projectOptions"
            @change="handleProjectChange"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <component
      :is="isMobile ? 'ExpensesViewMobile' : 'ExpensesViewDesktop'"
      :key="componentKey"
      :customer-id="customerId"
      :project-id="selectedProjectId"
      title-key="allMyExpenses"
      :show-project-column="true"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ExpensesViewDesktop from '@/components/expenses/ExpensesViewDesktop.vue'
import ExpensesViewMobile from '@/components/expenses/ExpensesViewMobile.vue'

export default {
  components: {
    ExpensesViewDesktop,
    ExpensesViewMobile,
  },
  data() {
    return {
      isMobile: false,
      selectedProjectId: null,
      projects: [],
    }
  },
  computed: {
    customerId() {
      return this.$route.params.customerId || null
    },
    projectOptions() {
      return [
        { text: this.$t('all'), value: null },
        ...this.projects.map(project => ({
          text: project.name,
          value: project.id,
        })),
      ]
    },
    componentKey() {
      return `all-expenses-${this.customerId || 'none'}-${this.selectedProjectId || 'all'}-${this.isMobile}`
    },
  },
  mounted() {
    this.checkScreen()
    window.addEventListener('resize', this.checkScreen)
    this.loadProjects()
  },
  watch: {
    customerId() {
      this.selectedProjectId = null
      this.loadProjects()
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreen)
  },
  methods: {
    ...mapActions('projects', ['fetchProjects']),
    checkScreen() {
      this.isMobile = window.innerWidth <= 768
    },
    handleProjectChange() {
      // La recarga ocurre vía componentKey
    },
    loadProjects() {
      if (!this.customerId) {
        this.projects = []
        return
      }
      this.fetchProjects({
        customerId: this.customerId,
        status: true,
        pagination: { page: 1, per_page: 1000, all: true },
      }).then(response => {
        this.projects = response?.data || []
      })
    },
  },
}
</script>
